<template>
  <v-navigation-drawer v-model="drawer" width="950" app temporary right class="wost-drawer">
    <div class="form-head">
      <template>
        <v-row>
          <v-col cols="7" class="pt-2 pb-0">
            <span>REGISTRO DE PAGO</span>
          </v-col>
          <v-col cols="2" class="pt-2 pb-0">
            <div class=" pl-0 pr-0" style="display:flex; justify-content: space-around">
              <span>
                <v-list-item-title>SERIE: </v-list-item-title>
              </span>
              <span>
                {{ this.serie }}
              </span>
            </div>
          </v-col>
          <v-col cols="3" class="pt-0 pb-0">
            <v-btn-toggle v-model="type_document_sale" mandatory dense color="green darken-3" class="float-right" @change="handleChangeTypeVoucher()">
              <v-btn value="TICKET" class="btn-show-mode" @click="handleChangeTypeVoucher()">
                TICKET
              </v-btn>
              <v-btn :value="type_document_customer" class="btn-show-mode" @click="handleChangeTypeVoucher()">
                {{ type_document_customer }}
              </v-btn>
            </v-btn-toggle>
          </v-col>
        </v-row>
      </template>
    </div>

    <div>
      <v-row no-gutters>
        <v-col :md="6" :sm="6" cols="12" class="pt-2 pl-2 pr-2">
          <v-card class="pay-card-list-products">
            <v-card-title class="pt-1 pb-1">
              <span class="subtitle-2">Detalle del Pedido</span>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pay-list-products">
              <v-list-item v-for="item in listProducts" :key="item.id" class="cart-item-product pl-0 pr-0" two-line flat>
                <template>
                  <v-list-item-content>
                    <v-list-item-title class="pay-product-name">
                      <v-icon v-if="item.is_bonus" color="amber" size="18" class="mr-1">
                        fas fa-gift
                      </v-icon>
                      <span>
                        {{ item.name }}
                      </span>
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      <span class="mr-4 pb-1 pay-product-quantity">Cantidad: {{ item.quantity }}</span>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action class="btn-quantity">
                    <div class="product-price">
                      <span class="label-price-discounted" v-if="item.discount_amount > 0">
                        {{ (item.base_price * item.quantity) | currency("S/") }}
                      </span>
                      <span class="ml-2">
                        {{ item.subtotal | currency("S/") }}
                      </span>
                    </div>
                  </v-list-item-action>
                </template>
              </v-list-item>
            </v-card-text>

            <v-card-text>
              <v-list-item class="cart-item-product pl-0 pr-0">
                <v-list-item-content class="pt-1 pb-1">
                  <v-list-item-title class="amount-discount">Descuento</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action class="btn-quantity amount-discount mt-2 mb-1">
                  {{ this.discount | currency("S/ ") }}
                </v-list-item-action>
              </v-list-item>
              <v-list-item class="cart-item-product pl-0 pr-0">
                <v-list-item-content class="pt-1 pb-1">
                  <v-list-item-title>Subtotal</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action class="btn-quantity amount-subtotal mt-2 mb-1">
                  {{ this.subtotal | currency("S/ ") }}
                </v-list-item-action>
              </v-list-item>
              <v-list-item class="cart-item-product pl-0 pr-0">
                <v-list-item-content class="pt-1 pb-1">
                  <v-list-item-title>IGV</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action class="btn-quantity amount-igv mt-2 mb-1">
                  {{ amount_igv | currency("S/ ") }}
                </v-list-item-action>
              </v-list-item>
              <v-list-item class="cart-item-product pl-0 pr-0">
                <v-list-item-content class="pt-1 pb-1">
                  <v-list-item-title>Total</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action v-if="order_id" class="btn-quantity mt-2 mb-1 font-weight-black">
                  {{ this.total_order | currency("S/ ") }}
                </v-list-item-action>
                <v-list-item-action v-else class="btn-quantity mt-2 mb-1 font-weight-black">
                  {{ this.total | currency("S/ ") }}
                </v-list-item-action>
              </v-list-item>

              <v-list-item v-if="order_id > 0 && type_order === 'order_payment'" class="cart-item-product pl-0 pr-0">
                <v-list-item-content class="pt-1 pb-1">
                  <v-list-item-title>A Cuenta</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action class="btn-quantity mt-2 mb-1 font-weight-black">
                  {{ this.total_payment | currency("S/ ") }}
                </v-list-item-action>
              </v-list-item>
              <v-list-item v-if="order_id > 0 && type_order === 'order_payment'" class="cart-item-product pl-0 pr-0">
                <v-list-item-content class="pt-1 pb-1">
                  <v-list-item-title>Saldo</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action class="btn-quantity mt-2 mb-1 font-weight-black">
                  {{ this.total_pending | currency("S/ ") }}
                </v-list-item-action>
              </v-list-item>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col :md="6" :sm="6" cols="12" class="pt-2 pl-2 pr-2">
          <v-card class="pay-detail">
            <v-card-title class="pt-1 pb-1">
              <span class="subtitle-2">Detalle del Pago</span>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="font-weight-black pb-0">
              Método de pago
            </v-card-text>
            <v-card-text class="pt-0 pb-0">
              <v-container class="pl-0 pr-0">
                <v-row>
                  <v-col cols="3">
                    <v-btn small dark color="green" block @click="handlePayCash()">
                      EFECTIVO
                    </v-btn>
                  </v-col>
                  <v-col cols="4">
                    <v-btn small dark color="indigo darken-4" block @click="handlePayTransfer()">
                      TRANSFERENCIA
                    </v-btn>
                  </v-col>
                  <v-col cols="3">
                    <v-btn small dark color="#ff9900" block @click="handlePayCard()">
                      TARJETA
                    </v-btn>
                  </v-col>
                  <v-col cols="2">
                    <v-btn small dark color="#742284" block @click="handlePayYape()">
                      YAPE
                    </v-btn>
                  </v-col>
                  <v-col cols="2">
                    <v-btn small dark color="#00E2CE" block @click="handlePayPlin()">
                      PLIN
                    </v-btn>
                  </v-col>
                  <!-- <v-col :md="6" :sm="6" cols="3" class="pt-0">
                    <v-btn block dark color="green darken-1 mt-1" height="48" @click="handlePayCash">
                      <v-icon class="mr-2 d-none d-sm-flex">far fa-money-bill-alt</v-icon>
                      CASH
                    </v-btn>
                  </v-col>
                  <v-col :md="2" :sm="2" cols="3" class="pt-0">
                    <v-btn text icon dark color="indigo darken-4" height="55"
                           @click="handlePayVisa">
                      <v-icon size="55">fab fa-cc-visa</v-icon>
                    </v-btn>
                  </v-col>
                  <v-col :md="2" :sm="2" cols="3" class="pt-0">
                    <v-btn text icon dark color="orange darken-2" height="55"
                           @click="handlePayMaster">
                      <v-icon size="55">fab fa-cc-mastercard</v-icon>
                    </v-btn>
                  </v-col>
                  <v-col :md="2" :sm="2" cols="3" class="pt-0">
                    <v-btn text icon dark color="blue darken-2" height="55"
                           @click="handlePayAmerican">
                      <v-icon size="55">fab fa-cc-amex</v-icon>
                    </v-btn>
                  </v-col> -->
                </v-row>
                <v-divider v-if="view_generate_voucher"></v-divider>
                <v-row v-if="view_generate_voucher">
                  <v-col cols="12" class="pt-2 pb-1">
                    <v-switch
                      v-model="generate_voucher"
                      class="mt-0"
                      label="GENERAR COMPROBANTE DE VENTA"
                      :true-value="true"
                      :false-value="false"
                      hide-details
                    ></v-switch>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-divider></v-divider>

            <v-card-text v-if="this.customer">
              <v-list-item class="cart-item-product pl-0 pr-0">
                <v-list-item-content>
                  <v-list-item-title>
                    Deuda Total
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action class="btn-quantity amount-igv">
                  {{ total_debt | currency("S/ ") }}
                </v-list-item-action>
              </v-list-item>
              <div v-if="amount_debt > 0" style="text-align: right;color: #E53935;">
                <span>Debe {{ amount_debt | currency("S/ ") }}</span>
              </div>
            </v-card-text>

            <v-card-text class="pt-0 pb-1">
              <template>
                <v-row v-if="pay_cash">
                  <v-col cols="8" class="pt-0 text-right">
                    <span class="title font-weight-medium">EFECTIVO</span>
                  </v-col>
                  <v-col cols="4" class="pt-0">
                    <v-text-field
                      outlined
                      solo
                      dense
                      hide-details
                      prefix="S/"
                      placeholder="0"
                      type="number"
                      :value="amount_cash"
                      @input="handleSetAmountCash"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="pay_transfer">
                  <v-col cols="8" class="pt-0 text-right">
                    <span class="title font-weight-medium">TRANSFERENCIA</span>
                    <!-- <v-autocomplete
                      v-model="bank_account_id"
                      :items="bank_accounts"
                      outlined
                      label="Cnta. Bancaria Transferencia"
                      persistent-hint
                      :item-text="customTextAccount"
                      item-value="id"
                      hide-details
                      dense
                      :filter="customFilterAccount"
                    >
                      <template v-slot:item="data">
                        <v-list-item-content>
                          <v-list-item-title>{{
                            data.item.bank_name
                          }}</v-list-item-title>
                          <v-list-item-subtitle
                            >{{ data.item.type }}:
                            {{ data.item.number_account }}</v-list-item-subtitle
                          >
                        </v-list-item-content>
                      </template>
                    </v-autocomplete> -->
                  </v-col>
                  <v-col cols="4" class="pt-0">
                    <v-text-field
                      outlined
                      solo
                      dense
                      hide-details
                      :value="amount_transfer"
                      prefix="S/"
                      placeholder="0"
                      type="number"
                      @input="handleSetAmountTransfer"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="pay_card">
                  <v-col cols="8" class="pt-0 text-right">
                    <!-- <span class="title font-weight-medium">TARJETA</span> -->
                    <v-combobox v-model="payment_gateway" :items="card_options" label="Seleccione Pasarela" outlined dense></v-combobox>
                  </v-col>
                  <v-col cols="4" class="pt-0">
                    <v-text-field
                      outlined
                      solo
                      dense
                      hide-details
                      :value="amount_card"
                      prefix="S/"
                      placeholder="0"
                      type="number"
                      @input="handleSetAmountCard"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="pay_yape">
                  <v-col cols="8" class="pt-0 text-right">
                    <span class="title font-weight-medium">YAPE</span>
                  </v-col>
                  <v-col cols="4" class="pt-0">
                    <v-text-field
                      outlined
                      solo
                      dense
                      hide-details
                      :value="amount_yape"
                      prefix="S/"
                      placeholder="0"
                      type="number"
                      @input="handleSetAmountYape"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="pay_plin">
                  <v-col cols="8" class="pt-0 text-right">
                    <span class="title font-weight-medium">PLIN</span>
                  </v-col>
                  <v-col cols="4" class="pt-0">
                    <v-text-field
                      outlined
                      solo
                      dense
                      hide-details
                      :value="amount_plin"
                      prefix="S/"
                      placeholder="0"
                      type="number"
                      @input="handleSetAmountPlin"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <!-- <v-row v-if="pay_cash">
                  <v-col cols="6" class="pt-0 text-right">
                    <span class="title font-weight-medium">CASH</span>
                  </v-col>
                  <v-col cols="6" class="pt-0">
                    <v-text-field
                      outlined
                      solo
                      dense
                      hide-details
                      prefix="S/"
                      placeholder="0"
                      type="number"
                      :value="amount_cash"
                      @input="handleSetAmountCash"
                    ></v-text-field>
                  </v-col>
                </v-row> -->
                <!-- <v-row v-if="pay_visa">
                  <v-col cols="6" class="pt-0 text-right">
                    <span class="title font-weight-medium">VISA</span>
                  </v-col>
                  <v-col cols="6" class="pt-0">
                    <v-text-field
                      outlined
                      solo
                      dense
                      hide-details
                      :value="amount_visa"
                      prefix="S/"
                      placeholder="0"
                      type="number"
                      @input="handleSetAmountVisa"
                    ></v-text-field>
                  </v-col>
                </v-row> -->
                <!-- <v-row v-if="pay_master">
                  <v-col cols="6" class="pt-0 text-right">
                    <span class="title font-weight-medium">MASTERCARD</span>
                  </v-col>
                  <v-col cols="6" class="pt-0">
                    <v-text-field
                      outlined
                      solo
                      dense
                      hide-details
                      :value="amount_master"
                      prefix="S/"
                      placeholder="0"
                      type="number"
                      @input="handleSetAmountMaster"
                    ></v-text-field>
                  </v-col>
                </v-row> -->
                <!-- <v-row v-if="pay_american">
                  <v-col cols="6" class="pt-0 text-right">
                    <span class="title font-weight-medium"
                      >AMERICAN EXPRESS</span
                    >
                  </v-col>
                  <v-col cols="6" class="pt-0">
                    <v-text-field
                      outlined
                      solo
                      dense
                      hide-details
                      :value="amount_american"
                      prefix="S/"
                      placeholder="0"
                      type="number"
                      @input="handleSetAmountAmerican"
                    ></v-text-field>
                  </v-col>
                </v-row> -->
              </template>
              <v-list-item class="section-vuelto pl-0 pr-0" v-if="amount_change > 0">
                <v-list-item-content>
                  <v-list-item-title class="text-right">
                    <span>Vuelto {{ amount_change | currency("S/ ") }}</span>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-card-text>

            <v-card-text class="pt-0 pb-0">
              <template>
                <v-row>
                  <v-col cols="6" class="pt-0">
                    <v-btn block outlined color="red darken-1" height="45" @click="handleCancelPayment">
                      Cancelar
                    </v-btn>
                  </v-col>
                  <v-col cols="6" class="pt-0">
                    <v-btn block dark color="green darken-1" height="45" @click="handleSavePayment" :disabled="press_button">
                      Pagar
                    </v-btn>
                  </v-col>
                </v-row>
              </template>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <v-dialog v-model="dialog" width="450" transition="fab-transition">
      <v-card class="pl-0 pr-0">
        <v-card-title>
          <span class="subtitle-2 font-weight-bold">
            SELECCIONE UN TIPO DE COMPROBANTE
          </span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pb-0">
          <v-container>
            <v-row dense>
              <v-col v-for="item in vouchers" :key="item.id" cols="12" md="4">
                <v-card
                  style=""
                  elevation="3"
                  link
                  :class="serie == item.correlative ? 'selected-card' : ''"
                  @click="handleChangeClickTypeVoucher(item)"
                >
                  <v-card-title class="pt-1">
                    <span>{{ item.correlative }}</span>
                  </v-card-title>
                  <v-card-text class="pt-0">
                    <div class="" style="display: flex; justify-content: space-between; align-items: center;">
                      <div class="text-center text-caption">
                        {{ item.type }}
                      </div>
                      <span class=" cash-amount" style="color: black;">{{ item.current_number }}</span>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-container class="pt-0 pb-0">
            <v-row justify="center">
              <v-col cols="12" md="6">
                <v-btn dark color="gray" block @click="handleCancelTypeVoucher">
                  Cerrar
                </v-btn>
              </v-col>
              <!-- <v-col cols="6">
                <v-btn dark color="green" block @click="handleSaveTypeVoucher">
                  Aceptar
                </v-btn>
              </v-col> -->
            </v-row>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";

import Tools from "../../helpers/Tools.js";

import printUtil from "@/plugins/print";
import TicketTools from "../../helpers/TicketTools";

import { APIService } from "@/APIService";

const apiService = new APIService();

import JQuery from "jquery";

let $ = JQuery;

export default {
  name: "PaymentForm",
  data() {
    return {
      titleForm: "Registro de pago",
      drawer: false,
      positive_balance: false,
      amount_balance: null,
      register_change: false,
      pay_cash: false,
      pay_visa: false,
      pay_master: false,
      pay_american: false,
      pay_transfer: false,
      pay_card: false,
      pay_yape: false,
      pay_plin: false,
      amount_cash: null,
      amount_visa: null,
      amount_master: null,
      amount_american: null,
      amount_transfer: null,
      amount_card: null,
      amount_yape: null,
      amount_plin: null,
      amount_change: 0,
      total_debt: 0,
      quantity_drums: null,
      amount_debt: 0,
      type_document_sale: "TICKET",
      type_document_customer: null,
      view_generate_voucher: false,
      generate_voucher: false,
      press_button: false,
      card_options: ["IZIPAY", "CULQUI"],
      serie: "-",
      dialog: false,
      variants: ["elevated", "flat", "tonal", "outlined", "text", "plain"],
      is_billing_enabled: true, // CAMBIA A true CUANDO TE PAGUEN
    };
  },
  computed: {
    ...mapState("authentication", ["companyData"]),
    ...mapState("voucher", ["vouchers"]),
    ...mapState("orders", ["order", "listStatus", "availableStatus", "deliveryman", "finalDeliveryman"]),
    ...mapState("payment", [
      "order_id",
      "listProducts",
      "customer",
      "discount",
      "subtotal",
      "amount_igv",
      "total",
      "total_return",
      "total_order",
      "total_payment",
      "total_pending",
      "type_order",
      "deliver_order",
    ]),
    getTotalDebt() {
      let debt = this.total;
      if (this.positive_balance) {
        debt = debt - this.customer.balance_favor;
      }
      return debt;
    },
  },
  methods: {
    ...mapActions("orders", [
      "selectOrder",
      "getAvailableStatus",
      "assignDeliveryman",
      "assignFinalDeliveryman",
      "replaceOrderUpdated",
      "getDeliveryUsers",
      "getToDispatch",
    ]),
    ...mapActions("payment", ["runSetOrderIdPay", "setDeliverOrder"]),
    ...mapActions("sales", ["clearData"]),
    ...mapActions("voucher", ["getVouchers"]),
    async showForm() {
      this.drawer = !this.drawer;
      this.total_debt = this.total;
      this.amount_debt = this.total;
      this.amount_balance = this.customer.balance_favor;
      this.type_document_sale = "TICKET"; // Forzamos que inicie en TICKET
      if (this.order.direct_sale == 1) {
        this.generate_voucher = true;
      } else {
        this.view_generate_voucher = true;
      }
      this.setTypeDocumentSale(this.customer);
      this.handleSearchTypeVoucher();
    },
    setTypeDocumentSale(customer) {
      if (customer) {
        if (customer.type_document == "DNI") {
          this.type_document_customer = "BOLETA";
        } else if (customer.type_document == "RUC") {
          this.type_document_customer = "FACTURA";
        }
      }
    },
    handlePayCash() {
      this.pay_cash = !this.pay_cash;
      if (!this.pay_cash) {
        this.amount_cash = null;
        this.calculateChange();
      }
    },
    handlePayVisa() {
      this.pay_visa = !this.pay_visa;
      if (!this.pay_visa) {
        this.amount_visa = null;
        this.calculateChange();
      }
    },
    handlePayMaster() {
      this.pay_master = !this.pay_master;
      if (!this.pay_master) {
        this.amount_master = null;
        this.calculateChange();
      }
    },
    handlePayAmerican() {
      this.pay_american = !this.pay_american;
      if (!this.pay_american) {
        this.amount_american = null;
        this.calculateChange();
      }
    },
    handlePayTransfer() {
      this.pay_transfer = !this.pay_transfer;
      this.bank_account_id = null;
      if (!this.pay_transfer) {
        this.amount_transfer = null;
        this.calculateChange();
      }
    },
    handlePayCard() {
      this.pay_card = !this.pay_card;
      this.payment_gateway = null;
      if (!this.pay_card) {
        this.amount_card = null;
        this.calculateChange();
      }
    },
    handlePayYape() {
      this.pay_yape = !this.pay_yape;
      if (!this.pay_yape) {
        this.amount_yape = null;
        this.calculateChange();
      }
    },
    handlePayPlin() {
      this.pay_plin = !this.pay_plin;
      if (!this.pay_plin) {
        this.amount_plin = null;
        this.calculateChange();
      }
    },
    handleCancelPayment() {
      this.setInitComponent();
      this.drawer = false;
    },
    setInitComponent() {
      this.positive_balance = false;
      this.register_change = false;
      this.pay_cash = false;
      this.pay_visa = false;
      this.pay_master = false;
      this.pay_american = false;
      this.pay_transfer = false;
      this.pay_card = false;
      this.pay_yape = false;
      this.pay_plin = false;
      this.amount_cash = null;
      this.amount_visa = null;
      this.amount_master = null;
      this.amount_american = null;
      this.amount_transfer = null;
      this.amount_card = null;
      this.amount_yape = null;
      this.amount_plin = null;
      this.amount_change = null;
      this.total_debt = 0;
      this.quantity_drums = null;
      this.type_document_sale = "TICKET";
      this.type_document_customer = null;
      this.view_generate_voucher = false;
      this.generate_voucher = false;
    },
    handleSavePayment() {
      if (this.serie == "-" || this.serie == null || this.serie == undefined) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "Seleccione una Serie",
          text: "",
        });
        this.press_button = false;
      } else {
        this.press_button = true;
        let payment = this.setEntityPayment();
        if (this.amount_debt > 0) {
          this.$swal({
            title: "¿Desea confirmar?",
            text: "El pago esta incompleto, desea continuar y registrar la deuda por un importe de S/" + this.amount_debt,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Confirmar",
            cancelButtonText: "Cancelar",
          }).then((result) => {
            if (result.value) {
              if (result.value === true) {
                payment.save_debt = true;
                if (this.order_id == null) {
                  this.registerOrder(payment);
                } else {
                  this.registerPayment("orders", payment);
                }
              } else {
                this.press_button = false;
              }
            } else {
              this.press_button = false;
            }
          });
        } else {
          if (this.order_id == null) {
            this.registerOrder(payment);
          } else {
            this.registerPayment("orders", payment);
          }
        }
      }
    },
    calculateTotalDebt() {
      let debt = this.total;
      if (this.positive_balance) {
        debt = debt - this.amount_balance;
      }
      return debt;
    },
    calculateChange() {
      let sum =
        Tools.getNumberDecimalValue(this.amount_cash) +
        Tools.getNumberDecimalValue(this.amount_visa) +
        Tools.getNumberDecimalValue(this.amount_master) +
        Tools.getNumberDecimalValue(this.amount_american) +
        Tools.getNumberDecimalValue(this.amount_transfer) +
        Tools.getNumberDecimalValue(this.amount_card) +
        Tools.getNumberDecimalValue(this.amount_yape) +
        Tools.getNumberDecimalValue(this.amount_plin);

      let amount_change = 0;
      let debt = this.total;
      if (this.positive_balance) {
        debt = debt - this.amount_balance;
      }
      if (sum > debt) {
        amount_change = sum - debt;
        this.amount_debt = 0;
      } else if (debt > sum) {
        this.amount_debt = debt - sum;
      } else if (debt == sum) {
        this.amount_debt = 0;
      }

      this.amount_change = amount_change;
    },
    handleSetAmountCash(value) {
      this.amount_cash = value;
      this.calculateChange();
    },
    handleSetAmountTransfer(value) {
      this.amount_transfer = value;
      this.calculateChange();
    },
    handleSetAmountCard(value) {
      this.amount_card = value;
      this.calculateChange();
    },
    handleSetAmountYape(value) {
      this.amount_yape = value;
      this.calculateChange();
    },
    handleSetAmountPlin(value) {
      this.amount_plin = value;
      this.calculateChange();
    },
    handleSetAmountVisa(value) {
      this.amount_visa = value;
      this.calculateChange();
    },
    handleSetAmountMaster(value) {
      this.amount_master = value;
      this.calculateChange();
    },
    handleSetAmountAmerican(value) {
      this.amount_american = value;
      this.calculateChange();
    },
    handleSetAmountBalance(value) {
      this.amount_balance = value;
      this.total_debt = this.total - this.amount_balance;
      this.calculateChange();
    },
    handleRegisterChange(value) {
      if (value) {
        this.register_change = true;
      } else {
        this.register_change = false;
      }
    },
    handleUsePositiveBalance(value) {
      if (value) {
        this.amount_balance = this.customer.balance_favor;
        this.total_debt = this.total - this.amount_balance;
      } else {
        this.amount_balance = 0;
        this.total_debt = this.total;
      }

      this.calculateChange();
    },
    registerPayment(source, payment) {
      let _vm = this;
      apiService
        .createPayment(payment)
        .then((response) => {
          console.log(response);
          this.press_button = false;
          this.handleCancelPayment();
          this.$notify({
            group: "foo",
            type: "success",
            title: "RESULTADO DE PAGO",
            text: "El pago se realizó de manera exitosa!",
          });
          this.handlePrintVoucher(response.data, this.companyData);
          if (source == "orders") {
            this.selectOrder(null);
            this.selectOrder(response.data);
            this.setDeliverOrder(false);
            this.getToDispatch();
          } else if (source == "sales") {
            this.clearData();
          }
        })
        .catch(function(error) {
          let data = error.response.data;
          if (data.error != undefined) {
            let error = data.error;
            console.log(error);
            if (error.name != undefined) {
              if (error.name == "Nubefact") {
                _vm.press_button = false;
                _vm.$notify({
                  group: "foo",
                  type: "error",
                  title: "RESULTADO DE PAGO",
                  text: error.error.errors,
                });
              }
            }
            if (error.message != undefined) {
              _vm.$notify({
                group: "foo",
                type: "error",
                title: "RESULTADO DE PAGO",
                text: error.message,
              });
              _vm.press_button = false;
            }
          } else {
            _vm.$notify({
              group: "foo",
              type: "error",
              title: "RESULTADO DE PAGO",
              text: "Ocurrió un error al registrar el pago.",
            });
            _vm.press_button = false;
          }
          // alert(error.response)
        });
    },
    registerOrder(payment) {
      apiService.createOrder(this.order).then((response) => {
        payment.order_id = response.data.id;
        this.registerPayment("sales", payment);
      });
    },
    setEntityPayment() {
      let payments = this.setListPayments();
      let payment = {
        typeVoucher: this.serie,
        order_id: this.order_id,
        discount: this.discount,
        subtotal: this.subtotal,
        igv: this.amount_igv,
        total: this.total,
        positive_balance: this.positive_balance,
        total_debt: this.total_debt,
        amount_change: this.amount_change,
        save_change: this.register_change,
        quantity_drums: this.quantity_drums,
        amount_cash: this.amount_cash,
        amount_transfer: this.amount_transfer,
        amount_card: this.amount_card,
        amount_yape: this.amount_yape,
        amount_plin: this.amount_plin,
        amount_visa: this.amount_visa,
        amount_master: this.amount_master,
        amount_american: this.amount_american,
        amount_balance: this.amount_balance,
        amount_debt: this.amount_debt,
        save_debt: false,
        deliver_order: this.deliver_order,
        generate_voucher: this.generate_voucher,
        type_document_sale: this.type_document_sale,
        payment_methods: payments,
      };

      return payment;
    },
    setListPayments() {
      let payments = [];
      if (this.amount_cash && this.amount_cash > 0) {
        let item = {
          method: "EFECTIVO",
          amount_debt: this.total,
          payment_amount: parseFloat(this.amount_cash),
          amount_change: Math.round(this.amount_change * 100) / 100,
          bank_account_id: null,
          payment_gateway: null,
        };
        payments.push(item);
      }
      if (this.amount_yape && this.amount_yape > 0) {
        let item = {
          method: "YAPE",
          amount_debt: this.total,
          payment_amount: parseFloat(this.amount_yape),
          amount_change: 0,
          bank_account_id: null,
          payment_gateway: null,
        };
        payments.push(item);
      }
      if (this.amount_plin && this.amount_plin > 0) {
        let item = {
          method: "PLIN",
          amount_debt: this.total,
          payment_amount: parseFloat(this.amount_plin),
          amount_change: 0,
          bank_account_id: null,
          payment_gateway: null,
        };
        payments.push(item);
      }
      if (this.amount_transfer && this.amount_transfer > 0) {
        let item = {
          method: "TRANSFERENCIA",
          amount_debt: this.total,
          payment_amount: parseFloat(this.amount_transfer),
          amount_change: 0,
          bank_account_id: this.bank_account_id,
          payment_gateway: null,
        };
        payments.push(item);
      }
      if (this.amount_card && this.amount_card > 0) {
        let item = {
          method: "TARJETA",
          amount_debt: this.total,
          payment_amount: parseFloat(this.amount_card),
          amount_change: 0,
          bank_account_id: null,
          payment_gateway: this.payment_gateway,
        };
        payments.push(item);
      }
      return payments;
    },
    /*
    printVoucher (sale, companyData) {
        let print = new printUtil()
        print.launch().then(() => {
            print.printTicketVenta(sale, companyData)
        });
    },
    */
    async handlePrintVoucher(sale, companyData) {
      if (sale) {
        if (sale.type_document == "FACTURA" || sale.type_document == "BOLETA" || sale.type_document == "TICKET") {
          let content = await TicketTools.generateVoucherSale(sale, companyData);
          this.printVoucher(content);
        }
      }
    },
    printVoucher(content) {
      $("<iframe>", { name: "voucheriframe", class: "printFrame" })
        .appendTo("body")
        .contents()
        .find("body")
        .append(content);

      window.frames["voucheriframe"].focus();
      setTimeout(() => {
        window.frames["voucheriframe"].print();
      }, 500);

      setTimeout(() => {
        $(".printFrame").remove();
      }, 1000);
    },

    async handleSearchTypeVoucher() {
      await this.getVouchers({ type: this.type_document_sale });
      const voucher = this.vouchers[0];
      if (this.vouchers.length == 1) {
        if (voucher) this.serie = voucher.correlative;
      } else {
        this.dialog = true;
      }
    },

    // handleChangeTypeVoucher() {
    //   this.handleSearchTypeVoucher();
    // },
    handleChangeTypeVoucher() {
      // Si intenta seleccionar algo que NO es TICKET y la facturación está desactivada
      if (this.type_document_sale !== "TICKET" && !this.is_billing_enabled) {
        this.$swal({
          title: "Módulo Restringido",
          text: "La emisión de Boletas y Facturas requiere la activación del módulo de facturación electrónica. Contacte con el proveedor.",
          icon: "info",
          confirmButtonText: "Entendido",
          confirmButtonColor: "#2E7D32",
        });

        // Revertimos automáticamente a TICKET
        this.$nextTick(() => {
          this.type_document_sale = "TICKET";
          this.handleSearchTypeVoucher(); // Recargamos la serie de ticket
        });

        return; // Salimos de la función
      }

      // Si tiene permiso o es TICKET, procedemos normal
      this.handleSearchTypeVoucher();
    },
    handleCancelTypeVoucher() {
      this.dialog = false;
    },
    handleSaveTypeVoucher() {},
    handleChangeClickTypeVoucher(voucher) {
      this.serie = voucher.correlative;
    },
  },
};
</script>

<style>
.pay-card-list-products {
  height: 90vh;
}

.pay-detail {
  height: 90vh;
  overflow-y: auto;
}

.pay-list-products {
  height: 40vh;
  overflow-y: auto;
}

.amount-discount {
  color: #e53935;
}

.amount-total {
  font-weight: bold;
  font-size: 1.5rem;
  color: #3f51b5;
}

.amount-subtotal {
  font-weight: bold;
}

.amount-igv {
  font-weight: bold;
}

.pay-product-quantity {
  font-weight: bold;
  font-size: 14px;
}

.pay-product-name {
  font-weight: bold;
  font-size: 0.8rem !important;
}

.bidones-devueltos {
  border-top: 1px solid;
}

.use-amount-balance {
  width: 100px;
}

.action-balance-favor {
  flex-direction: unset;
  align-items: center;
}

.bidones-a-devolver {
  display: block;
}

.selected-card {
  border: 1px solid #283593 !important; /* Cambia el color y grosor del borde según prefieras */
}
</style>
